import React from "react";
import { StyledTableLink } from "./table.styles";

/**
 * A table row's title/name cell as a link — bold foreground text rather than link-blue, per the
 * AP-1219 Study Paths spec. Defaults to opening in a new tab since every current caller does; pass
 * `target`/`rel` to override.
 */
function TableLink({ href, target = "_blank", rel = "noopener noreferrer", children, ...props }) {
    return (
        <StyledTableLink href={href} target={target} rel={rel} {...props}>
            {children}
        </StyledTableLink>
    );
}

TableLink.displayName = "TableLink";

export default TableLink;
